import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';
import HomeAction from '../actions/HomeAction';
import AddressSearchTypeahead from '../../components/AddressSearch/AddressSearchTypeahead/AddressSearchTypeahead';
import { HomeSelector } from '../reducers/HomeReducer';
import ConfigAction from '../actions/ConfigAction';

const mapStateToProps = (state, ownProps) => ({
  addressAutoComplete: HomeSelector.getAddressAutoComplete(state),
  isAddressSelected: HomeSelector.getIsAddressSelected(state),
  isLoading: HomeSelector.getIsLoading(state),
  isError: !isEmpty(HomeSelector.getError(state)),
  isChange: ownProps.isChange
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    fetchAddressAutoComplete: HomeAction.fetchAddressAutoComplete,
    fetchAddress: HomeAction.fetchAddress,
    storeStaticConfig: ConfigAction.storeStaticConfig
  }, dispatch);

const AddressSearchTypeaheadContainer = connect(mapStateToProps, mapDispatchToProps)(AddressSearchTypeahead);

export default AddressSearchTypeaheadContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/AddressSearchTypeaheadContainer.js
 **/